import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import infoIcon from '@ingka/ssr-icon/paths/information-circle';
import styled from 'styled-components';
import { SkapaColors, SkapaSSRIcon, SkapaText, SkapaTokens } from '@inter-ikea-guida/skapa';
import { StyledLabelText } from '../styles';
const StyledButton = styled.button `
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  text-align: start;
  margin-top: ${SkapaTokens.space50};
`;
const StyledInfoContainer = styled.div `
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  color: ${SkapaColors.colourTextAndIcon2};
`;
export const InfoButton = ({ buttonAriaLabel, description, onClick, subtle, text, dataTestId }) => {
    return (_jsxs(StyledButton, { onClick: onClick, "aria-label": buttonAriaLabel, "data-testid": dataTestId, children: [_jsxs(StyledInfoContainer, { children: [_jsx(StyledLabelText, { "$subtle": subtle, textStyle: 'Body.M', children: text }), _jsx(SkapaSSRIcon, { paths: infoIcon })] }), description && _jsx(SkapaText, { textStyle: 'Body.M', children: description })] }));
};
//# sourceMappingURL=InfoButton.js.map